import { API } from "../../utils/api";

import {
  deleteAdminVehicleItem,
  deleteUserVehicleItem,
  getAdminVehiclesList,
  getUserVehiclesList,
} from "../Reducers/VehiclesReducer";

export const getUserVehiclesListAction = (data, dispatch) =>
  API.getUserVehicles(data).then((res) => {
    if (res && res.data) {
      dispatch(getUserVehiclesList({ items: res.data }));
    }

    return res;
  });

export const deleteUserVehicleAction = (data, dispatch) =>
  API.deleteUserVehicle(data).then((res) => {
    if (res.type === "success") {
      dispatch(deleteUserVehicleItem({ id: data.id }));
    }

    return res;
  });

export const getAdminVehiclesListAction = (data, dispatch) =>
  API.getAdminVehicles(data).then((res) => {
    if (res && res.data) {
      dispatch(getAdminVehiclesList({ items: res.data }));
    }

    return res;
  });

export const deleteAdminVehicleAction = (data, dispatch) =>
  API.deleteAdminVehicle(data).then((res) => {
    if (res.type === "success") {
      dispatch(deleteAdminVehicleItem({ id: data.id }));
    }

    return res;
  });
